import { createElement, Component } from 'react';
import { AccordionConsumer } from './context';

export default function withAccordion(PassedComponent) {
  return class WithAccordion extends Component {
    render() {
      return createElement(AccordionConsumer, {
        children: (accordion) =>
          createElement(PassedComponent, {
            accordion,
            ...this.props,
          }),
      });
    }
  };
}
